import { jsx as _jsx } from "react/jsx-runtime";
import { forwardRef } from 'react';
import { Link } from 'react-router';
/** The design system's `LinkComponent` adapter: `href` → react-router `to`. */
export const RouterLink = forwardRef(function RouterLink({ href, children, ...rest }, ref) {
    return (_jsx(Link, { ref: ref, to: href, ...rest, children: children }));
});
//# sourceMappingURL=router-link.js.map